import React from 'react';
import './Slider.css';

const Slider = ({ min, max, value, onChange, showValue, unit }) => {
  const handleChange = (e) => {
    const newValue = parseFloat(e.target.value);
    onChange(newValue);
  };

  return (
    <div className="custom-slider">
      <input
        type="range"
        min={min}
        max={max}
        value={value}
        onChange={handleChange}
        className="slider-input"
      />
      {showValue && (
        <div className="slider-value">
          {value}{unit}
        </div>
      )}
    </div>
  );
};

export default Slider;